import {BaseStore} from '@/stores/base/baseStore';
export class BaseEstimateStore extends BaseStore {
  constructor(api) {
    const state = {
      itemDetails: [], // dữ liệu store chi tiết dự toán. Có thể bổ sung thêm thuyết minh
      itemDetailsAttach: [], // dữ liệu lưu file đính kèm
    };

    const actions = {
      /**
       * Lấy dữ liệu dự toán năm trước
       * @param {*} payload
       * @returns
       * tbngoc 12.03.2024
       */
      async getPreviousEstimate(payload) {
        return await api.getPreviousEstimate(payload);
      },


      /**
       * Lấy dữ liệu dự toán năm trước cơ sở tính
       * @param {*} payload
       * @returns
       * nhthai 02.10.2024
       */
      async getPreviousCalculationBasis(payload) {
        return await api.getPreviousCalculationBasis(payload);
      },

      /**
       * Lấy thông tin các bảng detail của bản ghi => trả về cả master
       * @param {*} payload: chứa {MasterId, columns, details)(array các detail)}
       * dvthuc 07/03/2024
       */
      async getEstimateDetail(payload) {
        const me = this;
        me.itemDetails = [];
        let res = [];
        try {
          if (typeof api.getEstimateDetail !== 'function') {
            throw new Error('Api getEstimateDetail not found');
          }
          res = await api.getEstimateDetail(payload || {});
          if (res) {
            res = this.afterGetDataDetailSuccess(res);
            me.itemDetails = res;
          }
        } finally {
        }
        return res;
      },

      /**
       * Xử lý dữ liệu sau khi lấy
       * @param {*} res
       * @returns
       */
      afterGetDataDetailSuccess(res) {
        return res;
      },

      /*
       * Lấy dữ liệu lập dự toán
       */
      async getEstimate(data) {
        const me = this;
        let res = [];
        try {
          me.loading = true;
          if (typeof api.getEstimate !== 'function') {
            throw new Error('Api getEstimate not found');
          }
          res = await api.getEstimate(data || {});
          if (Array.isArray(res)) {
            me.items = res;
          }
        } finally {
          me.loading = false;
        }

        return res;
      },

      /**
       * Api lấy file đính kèm
       * @param {*} payload
       * @returns
       */
      async getAttachDetail(payload) {
        const me = this;
        let res = [];
        try {
          if (typeof api.getAttachDetail !== 'function') {
            throw new Error('Api getAttachDetail not found');
          }
          res = await api.getAttachDetail(payload || {});
          if (Array.isArray(res)) {
            me.itemDetailsAttach = res.sort((a, b) => (a.sort_order ?? 0) - (b.sortOrder ?? 0));
          }
        } finally {
        }
        return res;
      },

      /**
       * thêm/sửa/xóa nhiều
       * @param {*} payload
       */
      async updateMultiple(payload) {
        const me = this;
        let res;
        try {
          if (typeof api.getAttachDetail !== 'function') {
            throw new Error('Api getAttachDetail not found');
          }
          res = await api.updateMultiple(payload || {});
          return res;
        } catch (error) {
          console.log(error);
        } finally {
        }
      },

      /**
       * Thêm file attach
       * @param {*} files
       * Thêm file đính kèm
       * @param {*} files
       */
      async addFileAttacth(files) {
        let me = this;
        if (Array.isArray(files) && Array.isArray(me.itemDetailsAttach)) {
          var sortOrder = me.itemDetailsAttach[me.itemDetailsAttach.length - 1]?.sort_order ?? 1;
          files.forEach(x => (x.sort_order = sortOrder++));
          me.itemDetailsAttach = me.itemDetailsAttach.concat(files);

          try {
            if (typeof api.saveAttachments !== 'function') {
              throw new Error('Api saveAttachments not found');
            }
            await api.saveAttachments(files || {});

            return true;
          } catch (error) {
            console.error(error);
            
            return false;
          } 
        }
      },

      /**
       * Xóa file đính kèm
       * @param {*} file
       */
      async deleteFileAttacth(file) {
        let me = this;
        if (Array.isArray(me.itemDetailsAttach)) {
          me.itemDetailsAttach = me.itemDetailsAttach.filter(
            x => x.estimate_attachment_id != file.estimate_attachment_id,
          );
          try {
            if (typeof api.deleteAttachment !== 'function') {
              throw new Error('Api deleteAttachment not found');
            }
            await api.deleteAttachment(file || {});
            return true;
          } catch (error) {
            console.error(error);

            return false;
          }
        }
      },

      /**
       * Lấy dữ liệu mặc định màn detail
       * nmtuan4 15.3.2024
       */
      async getDefaultData() {
        return await api.getDefaultData();
      },

      /**
       * update multi
       * @param {any} payload
       * @returns
       */
      async UpdateMutil(payload) {
        const me = this;
        let res = [];
        try {
          if (typeof api.UpdateMutil !== 'function') {
            throw new Error('Api UpdateMutil not found');
          }
          res = await api.UpdateMutil(payload);
        } finally {
        }
        return res;
      },

      /**
       * Cập nhật ngược vào list khi xóa
       * override lại để không xử dụng
       * @param {*} res
       * @returns
       */
      deleteItems(payload, res) {
      },
    };

    super(api);
    this.state = Object.assign(this.state, state);
    this.action = Object.assign(this.action, actions);
    this.getters = Object.assign(this.getters, {});
  }
}
